import { defineMessages } from 'react-intl';

const messages = defineMessages({
  titleArticles: {
    id: 'containers.MostVisitedArticles.titleArticles',
    defaultMessage: 'Most visited articles',
  },
  titleProducts: {
    id: 'containers.MostVisitedArticles.titleProducts',
    defaultMessage: 'Most visited products',
  },
});

export default messages;
